import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Scrolls to `#section` targets after route changes / full loads. Retries briefly
// because home-page sections render after data fetches.
export default function HashScroll() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) return undefined;
    const id = decodeURIComponent(hash.slice(1));
    let tries = 0;
    let settles = 0;
    let timer;
    const scrollTo = (el, smooth) => {
      const top = el.getBoundingClientRect().top + window.scrollY - 88; // fixed header offset
      window.scrollTo({ top, behavior: smooth ? 'smooth' : 'auto' });
    };
    const attempt = () => {
      const el = document.getElementById(id);
      if (el) {
        scrollTo(el, true);
        // Late-loading content above (portfolio feed, images) shifts layout — re-settle a few times.
        const settle = () => {
          const target = document.getElementById(id);
          if (target && Math.abs(target.getBoundingClientRect().top - 88) > 40) scrollTo(target, false);
          if (settles++ < 4) timer = setTimeout(settle, 500);
        };
        timer = setTimeout(settle, 700);
        return;
      }
      if (tries++ < 25) timer = setTimeout(attempt, 120);
    };
    attempt();
    return () => clearTimeout(timer);
  }, [pathname, hash]);

  return null;
}
